import { SupportedLanguages } from '@/config/i18n'
import {
  ApiFetchMenu,
  IMenuItem,
  MenuFilters,
  MenuMainCategory
} from '@/ducks/menu/menu.types'

const getFilteredResults = (
  data: ApiFetchMenu,
  filters: MenuFilters,
  language: SupportedLanguages
): MenuMainCategory[] => {
  const { search = '', mainCategories = [], status = 'all' } = filters

  const itemMatchesFilters = (item: IMenuItem): boolean => {
    const matchesSearch =
      !search ||
      item.name?.[language]?.toLowerCase().includes(search?.toLowerCase())
    const matchesStatus =
      status === 'all' ||
      (status === 'available' && item.isVisible) ||
      (status === 'unavailable' && !item.isVisible)

    return Boolean(matchesSearch && matchesStatus)
  }

  return data.menu.mainCategories
    .filter(
      category =>
        mainCategories?.length === 0 || mainCategories?.includes(category._id)
    )
    .map(category => {
      const filteredItems = category.items.filter(item =>
        itemMatchesFilters(item)
      )

      const filteredSubCategories = category.subCategories
        .map(subCategory => ({
          ...subCategory,
          items: subCategory.items.filter(item => itemMatchesFilters(item))
        }))
        .filter(subCategory => subCategory.items.length > 0)

      return {
        ...category,
        items: filteredItems,
        subCategories: filteredSubCategories
      }
    })
    .filter(
      category => category.items.length > 0 || category.subCategories.length > 0
    )
}
const checkItemsPresence = (categories?: MenuMainCategory[]) => {
  if (!categories) return false

  let hasItems = false
  for (const category of categories) {
    if (category.items?.length > 0) {
      hasItems = true
      break
    }
    if (category.subCategories?.length > 0) {
      for (const subCategory of category.subCategories) {
        if (subCategory.items?.length > 0) {
          hasItems = true
          break
        }
      }
    }
    if (hasItems) break
  }

  return hasItems
}

export { checkItemsPresence, getFilteredResults }
